import { useAtomValue } from "jotai";
import type { TOptions } from "i18next";
import { LanguageLabelsAtom } from "../store";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

// 翻訳テキストを変更するカスタムフック。
// options は i18next にそのまま渡す（count で単数・複数を選ぶ、{{...}} に値を差し込む など）
export const useModifiedTranslation = (): ((
  text: string,
  options?: TOptions,
) => string) => {
  const { t: i18nT } = useTranslation();
  const labels = useAtomValue(LanguageLabelsAtom);
  const currentLanguage = i18n.resolvedLanguage ?? "ja";

  const t = useCallback(
    (text: string, options?: TOptions): string => {
      let modifiedText = i18nT(text, options);

      const replacementRules = labels[currentLanguage] || {};

      // {}で囲まれた特定フレーズをルールに基づいて置換
      Object.entries(replacementRules).forEach(([key, replacement]) => {
        modifiedText = modifiedText.replace(
          new RegExp(`{${key}}`, "g"),
          replacement,
        );
      });

      return modifiedText;
    },
    [currentLanguage, i18nT, labels],
  );

  return t;
};
